module.exports = __webpack_public_path__ + "img/icon2.0f1e1f64.png";